import { render, staticRenderFns } from "./ListMenu.vue?vue&type=template&id=46b568c2&scoped=true&"
import script from "./ListMenu.vue?vue&type=script&lang=js&"
export * from "./ListMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b568c2",
  null
  
)

export default component.exports